<ng-container *transloco="let t; read: 'reports'">
<div class="p-5">
  <div>
    <drdp-title [title]="title"></drdp-title>
    <div>
      <p>
        {{ t('stateGroup.description') }}
      </p>
    </div>
  </div>
  <drdp-report-search [hasSubfilters]="true" [multiSelectAgencies]="true" [displaySite]="false" [displayClassroom]="false" [omitTestAgencies]="true"
    [multiSelectRatingPeriods]="true" [allAgenciesCheckbox]="true" [is2025]="is2025" [requiredFields]="requiredFields" [ratingPeriodLabel]="t('stateGroupDetail.ratingPeriodLabel')"
    [showReportBtnText]="t('actions.sendRequest')" (showReportClicked)="showReport($event)" [displayCounty]="true" [displayDownload]="false" [showSubfilterCheckAll]="false">
  </drdp-report-search>
</div>
</ng-container>
